import firebase from "store/firebase";
import "firebase/firestore";

import { subscribe } from "./listen-change";
import { eventFromDoc } from "./utils";
import { AnyAction, Dispatch } from "redux";
import type { RootState } from "store/reducer";
import { StoreError } from "store/errors";

// New action types for the list-level load. The `*_LIST_*` prefix avoids
// collision with the per-id id-resource action types under "events/*".
export const ACTION_EVENTS_LIST_LOADING = "events/list_loading";
export const ACTION_EVENTS_LIST_LOADED = "events/list_loaded";
export const ACTION_EVENTS_LIST_ERRORED = "events/list_errored";

// Backwards-compatible aliases — pre-existing tests / consumers reference
// these symbolic constants. The string values changed (the reducer is the only
// thing that cares), so keep the constant names but point them at the new
// strings.
export const ACTION_EVENTS_LOADING = ACTION_EVENTS_LIST_LOADING;
export const ACTION_EVENTS_LOAD = ACTION_EVENTS_LIST_LOADED;
export const ACTION_EVENTS_LOAD_ERROR = ACTION_EVENTS_LIST_ERRORED;

export default function load() {
  return async (
    dispatch: Dispatch<AnyAction>,
    getState: () => RootState
  ) => {
    const listRequestToken = (getState().events?.listRequestToken ?? 0) + 1;
    dispatch({
      type: ACTION_EVENTS_LIST_LOADING,
      payload: { listRequestToken },
    });
    try {
      const { auth } = getState();
      if (!auth.user?.email) {
        throw new StoreError("No current user.");
      }

      const relatedEventsColRef = firebase
        .firestore()
        .collection("events")
        .where("related", "array-contains", auth.user.email)
        .orderBy("date", "desc");
      const result = await relatedEventsColRef.get();
      const items = result.docs.map(eventFromDoc);
      dispatch({
        type: ACTION_EVENTS_LIST_LOADED,
        payload: { items, listRequestToken },
      });
      // Subscribe AFTER the commit so the listener's first snapshot can't race
      // the bulk LOAD action's items into the store.
      subscribe(auth.user.email);
    } catch (err) {
      const error =
        err instanceof StoreError
          ? err
          : new StoreError(err instanceof Error ? err.message : String(err));
      dispatch({
        type: ACTION_EVENTS_LIST_ERRORED,
        payload: { error, listRequestToken },
      });
    }
  };
}
